var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.145,
    height: 29.729,
    viewBox: "0 0 23.145 29.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ffad2c}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_284_51",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5205",
    transform: "translate(-467.636 85.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    d: "M480.041-73.739c0-.295 0-.985-1.532-.985-.188 0-.358 0-.509.015v2h.538c.727-.003 1.503-.273 1.503-1.03z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    d: "M478.437-70.56H478v2.553c.131 0 .281.007.452.007 1.255 0 1.892-.434 1.892-1.288 0-1.107-1.195-1.272-1.907-1.272z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    d: "M490.767-85.44h-23.122c-.021.021 0 3.3 0 3.3v26.429l11.561-4.955 11.561 4.955V-82.14s.033-3.229 0-3.3zm-8.9 18.544a5.363 5.363 0 0 1-3.776 1.077 15.2 15.2 0 0 1-2.027-.121l-.518-.072v-10.563l.476-.1a12.824 12.824 0 0 1 2.415-.214 4.58 4.58 0 0 1 3.043.84 2.606 2.606 0 0 1 1.03 2.181 2.723 2.723 0 0 1-.973 2.081 2.943 2.943 0 0 1 1.334 2.515 3.2 3.2 0 0 1-1.004 2.372z",
    className: "cls-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/B.01411a2ce66879eb06db53caff9784a0.svg";
export { ForwardRef as ReactComponent };